import {
  Delete20Regular,
  DesignIdeas20Regular,
  History20Regular,
  Pause20Regular,
  Play20Regular,
} from '@fluentui/react-icons';
import type { OverflowMenuItem } from '@/components/shared/OverflowMenu';
import type { Workflow } from '@/types/logicApps';
import { extractWorkflowName } from '@/types/logicApps';

interface CreateWorkflowActionMenuItemsOptions {
  workflow: Workflow;
  canEdit: boolean;
  isPermissionsLoading: boolean;
  isStateActionDisabled: boolean;
  onOpenDesigner: (workflowName: string) => void;
  onViewRuns: (workflowName: string) => void;
  onToggleState: (workflowName: string, disable: boolean) => void;
  onDelete: (workflowName: string) => void;
}

export const createWorkflowActionMenuItems = ({
  workflow,
  canEdit,
  isPermissionsLoading,
  isStateActionDisabled,
  onOpenDesigner,
  onViewRuns,
  onToggleState,
  onDelete,
}: CreateWorkflowActionMenuItemsOptions): OverflowMenuItem[] => {
  const workflowName = extractWorkflowName(workflow.name);
  const isDisabled = workflow.properties?.state === 'Disabled';
  const items: OverflowMenuItem[] = [
    {
      label: 'Open designer',
      icon: DesignIdeas20Regular,
      onClick: () => onOpenDesigner(workflowName),
    },
    {
      label: 'View runs',
      icon: History20Regular,
      onClick: () => onViewRuns(workflowName),
    },
  ];

  if (isPermissionsLoading) {
    items.push(
      {
        label: isDisabled ? 'Enable' : 'Disable',
        icon: isDisabled ? Play20Regular : Pause20Regular,
        disabled: true,
        onClick: () => undefined,
      },
      {
        label: 'Delete',
        icon: Delete20Regular,
        danger: true,
        dividerBefore: true,
        disabled: true,
        onClick: () => undefined,
      },
    );
  } else if (canEdit) {
    items.push(
      {
        label: isDisabled ? 'Enable' : 'Disable',
        icon: isDisabled ? Play20Regular : Pause20Regular,
        disabled: isStateActionDisabled,
        onClick: () => onToggleState(workflow.name, !isDisabled),
      },
      {
        label: 'Delete',
        icon: Delete20Regular,
        danger: true,
        dividerBefore: true,
        onClick: () => onDelete(workflowName),
      },
    );
  }

  return items;
};
